import React, { Suspense, useRef, useState, useEffect, useMemo } from 'react'
import './App.css';
import * as THREE from 'three';
import { Stats, Html, Center, OrbitControls, MeshDistortMaterial } from '@react-three/drei';
import { Canvas, extend, useThree, useFrame } from '@react-three/fiber'
import { useLoader } from '@react-three/fiber'
import { useTexture } from '@react-three/drei';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import Boxes  from './Boxes.js';

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass'
import { SSAOPass } from 'three/examples/jsm/postprocessing/SSAOPass'
import { BokehPass } from 'three/examples/jsm/postprocessing/BokehPass'
import { TextureLoader } from 'three/src/loaders/TextureLoader.js';
import { MeshBasicMaterial } from 'three';
import { MeshStandardMaterial } from 'three';
import { Vector3 } from 'three';
import { Color } from 'three';

extend({ EffectComposer, RenderPass, UnrealBloomPass, SSAOPass, BokehPass });


function Effect({ down }) {
  const composer = useRef()
  const { scene, gl, size, camera } = useThree()
  const aspect = useMemo(() => new THREE.Vector2(size.width, size.height), [size])
  const params = useMemo(() => ({ focus: 1, aperture: 0.005, maxblur: 0.018 }), [])
  useEffect(() => void composer.current.setSize(size.width, size.height), [size])
  useFrame(() => composer.current.render(), 1)
  return (
    <>
    <effectComposer ref={composer} args={[gl]}>
      <renderPass attachArray="passes" scene={scene} camera={camera} />
      {/* <sSAOPass attachArray="passes" args={[scene, camera, 1024, 1024]} kernelRadius={5.8} maxDistance={5.4} /> */}
      <unrealBloomPass attachArray="passes" args={[aspect, 0.5, 0.5, 0]} />
      {/* <bokehPass attachArray="passes" args={[scene, camera, params]} /> */}
    </effectComposer>
    </>
  )
}



const params = new URLSearchParams(window.location.search);
const viewer = params.get('viewer');
let viewerIsOwner = false;
let objkt = parseInt(params.get("objkt"), 10);

const query = `
query Objkt($id: bigint!) {
  hic_et_nunc_token_by_pk(id: $id) {
    token_holders(where: {quantity: {_gt: "0"}}, order_by: {id: asc}) {
      quantity
      holder {
        address
        name
      }
    }
  }
}
`;


async function fetchGraphQL(operationsDoc, operationName, variables) {
  const result = await fetch(
    "https://api.hicdex.com/v1/graphql",
    {
      method: "POST",
      body: JSON.stringify({
        query: operationsDoc,
        variables: variables,
        operationName: operationName
      })
    }
  );

  return await result.json();
}

async function doFetch() {
  if(!objkt) return;
  const { errors, data } = await fetchGraphQL(query, "Objkt", {"id":objkt});
  if (errors) {
    console.error(errors);
  }
  else 
  {
    const result = data.hic_et_nunc_token_by_pk;
    console.log({ result });
    return result;
  }
}

function checkViewerIsOwner(data) {
  if(!data || !data.token_holders) return;
  if (data.token_holders.some((e) => e.holder.address === viewer)) {
    console.log(`viewer IS owner`);
    viewerIsOwner = true;
  } else {
    console.log(`viewer is NOT owner`);
  }
  //console.log({ OBJKT: data });
}

function changeData(data, id) {
  let characters = [];
  console.log("Refreshing");
  if(!data || !data.token_holders) return;
  curData = curData.concat(data.token_holders.map((holder) => { return holder.holder.name ? holder.holder.name : 
    holder.holder.address.substr(0,4) + "..." + holder.holder.address.substr(-4);}));
  for (let i = curData.length - 1; i > data.length * id; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [curData[i], curData[j]] = [curData[j], curData[i]];
  }
  
  for(let i=0; i < curData.length; i++)
  {
    characters.push([(i % 8) * 2 - 7.5 + Math.random(), 18]);
  }
  
  console.log(curData)
  return characters;
}

// let data = doFetch();

let models = [], count = 0, curData=[];
for(let i=0; i < 10; i++)
{
  for(let j=0; j < 9; j++)
  {
    models[count++] = [i, j];
  }
}

function RecursiveBox({size, pos, depth}) {
  console.log(size[0]*size[1]*size[2])
  if(depth > 5) 
    return (
    <mesh position={pos}>
      <boxGeometry args={size} />
      <meshBasicMaterial color={'hsl(' + Math.random()*345 + ', 100%, 50%)'} />
    </mesh>
  );

  let lSize = [size[0] * Math.random(), size[1], size[2]];
  let rSize = [size[0] - lSize[0], size[1], size[2]];

  let lPos = [pos[0] - size[0]/2 + lSize[0] / 2,  pos[1], pos[2]];
  let rPos = [pos[0] + size[0]/2 - rSize[0] / 2,  pos[1], pos[2]];
  console.log(lSize, lPos)
  return <>
    <RecursiveBox size={lSize} pos={lPos} depth={depth+1}/>
    <RecursiveBox size={rSize} pos={rPos} depth={depth+1}/>
  </>
}

function Sphere({pos}) {
  return <mesh position={pos}>
           <sphereGeometry args={[1,16,16]} />
           <meshStandardMaterial color={'purple'}/>
         </mesh>
}

function Model() {
  const gltf = useLoader(GLTFLoader, './arms.glb');
  console.log(gltf.scene)
  return (
    <>
    <primitive object={gltf.scene.children[1]} scale={[1,0.9,1]}>
      <meshPhysicalMaterial color={0x151515} />
    </primitive>
    
    {/* <primitive object={gltf.scene} scale={[0.1,0.1,0.1]}>
      <meshPhysicalMaterial color={0x151515} />
    </primitive> */}
    </>)
}

function InnerCircle({ count, index, size, rotation, pos, color, scale, rAspect }) {
  const mesh = useRef();
  const gltf = useLoader(GLTFLoader, './arms.glb');
  console.log(gltf.scene.children[0].geometry.attributes.position.array)
  const { mouse, camera } = useThree();
  let lastTime = 0;

  const dummy = useMemo(() => new THREE.Object3D(), [])
  
  const particles = useMemo(() => {
    const temp = [];
    for (let i = 0; i < count; i++) {
      const endLife = Math.random() * 10;
      const life = 0;
      const start = new THREE.Vector3(0,0,0);
      const next = new THREE.Vector3(0,0,0);

      temp.push({ start, next, life, endLife })
    }
    return temp
  }, [count])
  
  useFrame(({clock}) => {
    camera.position.set(Math.sin(mouse.x * 2) / 4, -0.52,  Math.cos(mouse.x * 2) / 4);
    camera.lookAt(new THREE.Vector3(0, mouse.y / 2 - 0.5,0));
    
    // Go through each particle
    particles.forEach((particle, i) => {
      let { start, next } = particle
      // Change position
      let t = particle.life / particle.endLife;
      dummy.position.copy(start.lerp(next, t));
      dummy.scale.set( t + 0.3, t + 0.3, t + 0.3);
      dummy.updateMatrix();
      // And apply the matrix to the instanced mesh
      mesh.current.setMatrixAt(i, dummy.matrix)

      particle.life += (clock.elapsedTime - lastTime);
      if(particle.life >= particle.endLife) {
        particle.endLife = Math.random() * 10;
        particle.life = 0;
        let geometry = gltf.scene.children[index].geometry.attributes.position.array;
        let rand = Math.floor(Math.random() * geometry.length / 3) * 3;
        let randPoint = new THREE.Vector3(geometry[rand], geometry[rand+1], geometry[rand+2]);
        particle.start = particle.next;

        let rand2 = Math.floor(Math.random() * geometry.length / 3) * 3;
        let randPoint2 = new THREE.Vector3(geometry[rand2] + Math.random() * rAspect, 
                                            geometry[rand2+1], 
                                            geometry[rand2+2] + Math.random() * rAspect);
        particle.next = randPoint2;
      } 
    })
    lastTime = clock.elapsedTime;
    mesh.current.instanceMatrix.needsUpdate = true
  })
  return (
    <>
      <instancedMesh ref={mesh} args={[null, null, count]} rotation={rotation} position={pos} scale={scale}>
        <dodecahedronBufferGeometry attach="geometry" args={[size, 0]} />
        <meshStandardMaterial attach="material" color={color} />
      </instancedMesh>
    </>
  )
}

function Trails() {
  
    const { scene, camera, gl } = useThree();
    camera.near = 0.01;
    camera.updateProjectionMatrix();
    gl.autoClearColor = false;


    var fadeMaterial = new THREE.MeshBasicMaterial({
        color: 0x000000,
        transparent: true,
        opacity: 0.1
    });
    var fadePlane = new THREE.PlaneBufferGeometry(100, 100);
    var fadeMesh = new THREE.Mesh(fadePlane, fadeMaterial);

    if(camera.children.length === 0) {
        camera.add(fadeMesh);
        scene.add(camera);
        
    }

    fadeMesh.position.set(0,0,-1);
    fadeMesh.rotation.set(0, 0, Math.PI / 2)

    fadeMesh.renderOrder = 1;
  return null;
}

function SkyBox() {
  const { scene } = useThree();
  const loader = new THREE.CubeTextureLoader();
  // The CubeTextureLoader load method takes an array of urls representing all 6 sides of the cube.
  const texture = loader.load([
    "1.jpg",
    "2.jpg",
    "3.jpg",
    "4.jpg",
    "5.jpg",
    "6.jpg"
  ]);

  // Set the scene background property to the resulting texture.
  scene.background = texture;
  return null;
}

function App() {
  const [id, setId] = useState(0);
  const [characters, set] = useState([]);

  useEffect(() => {
    // doFetch(objkt)
    //   .then((data) => changeData(data, id))
    //   .then((char) => set(char));
  }, [id])


  return (
    <div id="wrapper" onMouseDown={() => {console.log("PRESSED")}}>
  <Canvas>
    <color attach="background" args={"black"} />
    <Effect />
      <ambientLight intensity = {0.1} />
      <pointLight position={[0,-0.5,0]} intensity={8.0} color={'red'} />
      {/* <RecursiveBox pos={[0,0,0]} size={[10,10,10]} depth={0}/> */}
      {/* <Organism /> */}
      {/* <Boxes amount={1000} wireframe={true}/> */}
      <Suspense fallback={null}>
        <InnerCircle count={6000} size={0.005} index={0} rotation={[-Math.PI / 2, 0, 0]} pos={[-0.02,-0.2,-0.02]} color={0x996611} scale={[0.8,0.9,0.8]} rAspect={0}/>
        {/* <InnerCircle count={10000} size={0.005} index={1} color={'purple'} pos={[0,-2,0]} scale={[1,1,1]} rAspect={2}/> */}
        <Model />
        <Trails />
        {/* <SkyBox /> */}
      </Suspense>
    {/* <OrbitControls />  */}
    {/* <Stats /> */}
  </Canvas>
  </div>
  );
}

export default App;
